import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import appApi from '../../../../../../api/app-api';

export const deleteCheckPaymentServiceOperation = async (
  checkId: number,
  setDeleteCheckId: (id: number | null) => void,
) => {
  try {
    setDeleteCheckId(checkId);

    const res = await appApi.deleteCheckStatusPaymentService(checkId);

    if (res.data.ok) {
      await globalSettingsStores.fetchSetting();
      toast.success('השרות נמחק בהצלחה');
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    }
    setDeleteCheckId(null);
  } catch (e) {
    setDeleteCheckId(null);
    console.error(
      `deleteCheckPaymentServiceOperation is failed with the checkId: ${checkId}, and the error: ${e}`,
    );
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
  }
};
